import { Colors } from "@/enums/Colors";
import { Switch, SwitchProps, styled } from "@mui/material";

const CommonSwitch = styled((props: SwitchProps) => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(
  ({ theme }) => ({
    width: "2.625rem",
    height: "1.625rem",
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: "0.125rem",
      color: `${Colors.BUTTON_PURPLE}`,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(1rem)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: `${Colors.BUTTON_PURPLE}`,
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: `${Colors.BUTTON_PURPLE}`,
        border: "0.375rem solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: theme.palette.grey[100],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.7,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: "1.375rem",
      height: "1.375rem",
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: `${Colors.BUTTON_SECONDARY_PURPLE}`,
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  })
);

export default CommonSwitch;
